// AI Generated Component
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pages-with-duplicate-title-titles',
    templateUrl: './pages-with-duplicate-title-titles.component.html',
    standalone: false,
})
export class PagesWithDuplicateTitleTitlesComponent {
    @Input() selectedTitle: any = null;
    @Input() titles: any[] = [];
    @Input() currentSort: any = { by: 'title', direction: 'desc' };
    @Input() promise: Promise<any> | null = null;

    @Output() onPerPageChange = new EventEmitter<number>();
    @Output() onPageChange = new EventEmitter<number>();
    @Output() onSortPage = new EventEmitter<any>();
    @Output() selectedTitleChange = new EventEmitter<any>();

    changeSelectedTitle (title: any): void {
        this.selectedTitle = title;
        this.selectedTitleChange.emit(title);
    }

    pageChange (page: number): void {
        this.onPageChange.emit(page);
    }

    perPageChange (pageSize: any): void {
        this.onPerPageChange.emit(pageSize);
    }

    onSortChanged (sortEvent: any): void {
        this.onSortPage.emit(sortEvent);
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
